import React, { useState, useEffect, useRef } from 'react'
import close from '../../../assets/images/close.svg'
import down from '../../../assets/images/icondropdown.svg'
import fillStar from '../../../assets/images/icon-fillStar.png'
import emptyStar from '../../../assets/images/icon-emptyStart.png'
import { getAllProductsWithoutPagination } from '../../../api/productsApi'

const AddReview = ({ showAddReviewPopup, popupRef, errorMessage, formData, handleChange, setShowAddReviewPopup, handleSubmit, styles, editingReview, isLoading }) => {
    const [products, setProducts] = useState([])
    const [productsLoading, setProductsLoading] = useState(false)
    const [openProduct, setOpenProduct] = useState(false)

    const productDropdownRef = useRef()

    useEffect(() => {
        if (showAddReviewPopup) {

            const fetchProducts = async () => {
                setProductsLoading(true)
                try {
                    const response = await getAllProductsWithoutPagination()
                    setProducts(response?.data?.data || [])
                } catch (error) {
                    console.error('Failed to fetch products:', error)
                    setProducts([])
                } finally {
                    setProductsLoading(false)
                }
            }

            fetchProducts()
        }
    }, [showAddReviewPopup])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (productDropdownRef.current && !productDropdownRef.current.contains(event.target)) {
                setOpenProduct(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <>
            {showAddReviewPopup && (
                <>
                    <div className="popup-overlay"></div>
                    <div className="popup-box add-new-user" ref={popupRef}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowAddReviewPopup(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>{editingReview ? 'Edit Review' : 'Add New Review'}</div>
                        <div className="popup-form">
                            <div className="form-group">
                                <label>Name</label>
                                <input type="text"
                                    className='form-input'
                                    name='name'
                                    value={formData?.name}
                                    onChange={handleChange}
                                    placeholder="Enter name"
                                />
                                {errorMessage?.name && <p className='error-message'>{errorMessage?.name}</p>}
                            </div>
                            <div className="form-group">
                                <label>Product</label>
                                <div className="dropdown-wrapper review-dropdown" ref={productDropdownRef}>
                                    <div className="dropdown-header" onClick={() => !productsLoading && setOpenProduct(!openProduct)}>
                                        <div>
                                            {formData?.productId?.title || formData?.product?.title || "Select Product"}
                                        </div>
                                        <span className={`arrow ${openProduct ? "rotate" : ""}`}><img src={down} alt="dropdown-image" /></span>
                                    </div>
                                    {openProduct && !productsLoading && (
                                        <div className="dropdown-list">
                                            {products.map((item, index) => (
                                                <label key={index}
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                        handleChange({
                                                            target: {
                                                                name: "productId",
                                                                value: item,
                                                            },
                                                        });
                                                        setOpenProduct(false);
                                                    }}>
                                                    <span>{item?.title}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {errorMessage?.productId && <p className='error-message'>{errorMessage?.productId}</p>}
                            </div>
                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className='form-input description'
                                    name='review'
                                    value={formData?.review}
                                    onChange={handleChange}
                                    placeholder="Enter review description"
                                    rows="5"
                                />
                                {errorMessage?.review && <p className='error-message'>{errorMessage?.review}</p>}
                            </div>

                            <div className={styles.ratingBox}>

                                {/* PRICE */}
                                <div className={styles.ratingRow}>
                                    <p className={styles.ratingLabels}>Price</p>
                                    <div>
                                        <div className={styles.ratingStars}>
                                            {[...Array(5)].map((_, index) => (
                                                <img key={index}
                                                    src={index < formData.priceRating ? fillStar : emptyStar}
                                                    alt="star" className={styles.ratingStar}
                                                    onClick={() =>
                                                        handleChange({
                                                            target: {
                                                                name: "priceRating",
                                                                value: index + 1,
                                                            },
                                                        })
                                                    }
                                                />
                                            ))}
                                        </div>
                                        {errorMessage?.priceRating && <p className='error-message'>{errorMessage?.priceRating}</p>}
                                    </div>
                                </div>

                                {/* VALUE */}
                                <div className={styles.ratingRow}>
                                    <p className={styles.ratingLabels}>Value</p>
                                    <div>
                                        <div className={styles.ratingStars}>
                                            {[...Array(5)].map((_, index) => (
                                                <img
                                                    key={index}
                                                    src={index < formData.valueRating ? fillStar : emptyStar}
                                                    alt="star"
                                                    className={styles.ratingStar}
                                                    onClick={() =>
                                                        handleChange({
                                                            target: {
                                                                name: "valueRating",
                                                                value: index + 1,
                                                            },
                                                        })
                                                    }
                                                />
                                            ))}
                                        </div>
                                        {errorMessage?.valueRating && <p className='error-message'>{errorMessage?.valueRating}</p>}
                                    </div>
                                </div>

                                {/* QUALITY */}
                                <div className={styles.ratingRow}>
                                    <p className={styles.ratingLabels}>Quality</p>
                                    <div>
                                        <div className={styles.ratingStars}>
                                            {[...Array(5)].map((_, index) => (
                                                <img
                                                    key={index}
                                                    src={index < formData.qualityRating ? fillStar : emptyStar}
                                                    alt="star"
                                                    className={styles.ratingStar}
                                                    onClick={() =>
                                                        handleChange({
                                                            target: {
                                                                name: "qualityRating",
                                                                value: index + 1,
                                                            },
                                                        })
                                                    }
                                                />
                                            ))}
                                        </div>
                                        {errorMessage?.qualityRating && <p className='error-message'>{errorMessage?.qualityRating}</p>}
                                    </div>
                                </div>

                            </div>

                            <div className="popup-actions">
                                <button className="cancel-btn" onClick={() => setShowAddReviewPopup(false)}>Cancel</button>

                                <button disabled={isLoading} className={`${styles.primaryButton} ${editingReview ? 'update-review-btn' : styles.saveButton}`} onClick={handleSubmit}>
                                    {
                                        isLoading ?
                                            <div className={`ringLoader loaderContinue`}></div> : <>{editingReview ? 'Update' : 'Save'}</>
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default AddReview
